import React, { useState, useEffect } from 'react';
import {
  Box, Typography, TextField, Button, Grid, IconButton, Modal, Paper
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from 'axios';

const DynamicValuesManager = () => {
  const [dynamicValues, setDynamicValues] = useState([]);
  const [editedValues, setEditedValues] = useState({});
  const [selectedValue, setSelectedValue] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const token = localStorage.getItem('token');

  const fetchValues = () => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/dynamicvalues`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setDynamicValues(res.data))
      .catch((err) => console.error('Fetch dynamic values error:', err));
  };

  useEffect(() => {
    fetchValues();
  }, []);

  const handleChange = (id, value) => {
    setEditedValues((prev) => ({ ...prev, [id]: value }));
  };

  const handleUpdate = (id) => {
    const updatedValue = editedValues[id];
    if (updatedValue == null) return;

    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/dynamicvalues/${id}`,
        { fieldvalue: updatedValue },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        setEditedValues((prev) => {
          const copy = { ...prev };
          delete copy[id];
          return copy;
        });
        fetchValues();
      })
      .catch((err) => console.error('Update error:', err));
  };

  const handleView = (value) => {
    setSelectedValue(value);
    setOpenModal(true);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Dynamic Values</Typography>
      <Grid container spacing={2}>
        {dynamicValues.map((item) => (
          <Grid item xs={12} md={6} key={item.id}>
            <Typography variant="body1"><strong>{item.fieldname}</strong></Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
              <TextField
                fullWidth
                value={editedValues[item.id] ?? item.fieldvalue}
                onChange={(e) => handleChange(item.id, e.target.value)}
                variant="outlined"
                size="small"
              />
              <IconButton onClick={() => handleView(item.fieldvalue)} sx={{ ml: 1 }}>
                <VisibilityIcon />
              </IconButton>
            </Box>
            <Button
              variant="contained"
              onClick={() => handleUpdate(item.id)}
              sx={{ mt: 1 }}
            >
              Update
            </Button>
            <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
              Updated: {new Date(item.updatedDate).toLocaleString()} by {item.created_by}
            </Typography>
          </Grid>
        ))}
      </Grid>

      {/* View Modal */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Paper
          sx={{
            position: 'absolute',
            top: '50%', left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            maxHeight: '80vh',
            overflowY: 'auto',
            p: 3,
          }}
        >
          <Typography variant="h6" gutterBottom>Full Field Value</Typography>
          <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>{selectedValue}</Typography>
        </Paper>
      </Modal>
    </Box>
  );
};

export default DynamicValuesManager;
